/*
 * @description: 
 * @author: Jason Wong
 * @since: 2024-12-16 13:15:34
 */
/**
 *
 * @author: Mengyu Jin
 * @since: 2022-10-19 09:52:24
 */
 import { isBlank } from "@/utils/String";
 import { uuid } from "@/utils/uuid";
/**
 * 返回上一 tab
 */
function closeAndGotoParent() {
  console.log("#-# close", window);
  if (window.opener) {
    if (isBlank(window.opener.name)) {
      window.opener.name = uuid();
    }
    window.open("", window.opener.name);
  }
  window.close();
}

export { closeAndGotoParent };
